import styled, { css } from "styled-components";

const textParagraphSmRegular = css`
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 400;
`;

export const BaseTextarea = styled.textarea<{ disabled?: boolean; borderColor?: string; error?: boolean }>`
  ${textParagraphSmRegular}
  border-radius: 4px;
  border: 1px solid;
  border-color: ${props => props.borderColor || (props.error ? "#F3322B" : "var(--general-border, #e2e8f0)")};

  padding: 1rem;
  min-height: 120px;
  width: 100%; 
  color: #0f172a;
  
  resize: vertical; 

  &:focus {
    outline: none;
    border-color: var(--general-border, #3754e2); 
  }

  ${({ disabled }) =>
    disabled &&
    `
      opacity: 0.5;
      cursor: not-allowed;
      background-color: #f7fafc;
  `}

  ::placeholder {
    color: #d1d5db;
  }
`;
